var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 272,
    viewBox: "0 0 263 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262.5 155.312C262.5 156.297 262.478 157.281 262.391 158.244C261.144 177.297 247.625 193.266 229.316 197.772C228.047 206.631 223.628 214.594 217.132 220.325C213.756 223.336 209.856 225.701 205.625 227.303V227.5C205.625 240.712 195.825 251.672 183.116 253.487C180.994 258.059 177.822 261.953 173.907 264.95C169.352 268.433 163.909 270.563 158.2 271.097C157.26 271.206 156.297 271.25 155.313 271.25C145.557 271.25 136.872 266.634 131.25 259.503C117.163 243.622 106.707 227.741 99.2034 212.1C94.0768 201.556 90.0806 190.498 87.2816 179.112C64.7722 87.3687 131.25 11.7469 131.25 11.7469C136.872 4.61562 145.557 0 155.313 0C164.172 0 172.135 3.69688 177.691 9.66875C180.71 12.8625 183.007 16.6906 184.407 20.9562C187.732 20.125 191.166 19.6875 194.688 19.6875C217.613 19.6875 236.25 38.325 236.25 61.25C236.25 62.9781 236.141 64.7062 235.944 66.3906C250.557 72.3406 260.313 86.5375 260.313 102.812C260.31 111.55 257.401 120.038 252.044 126.941C258.76 134.794 262.5 144.834 262.5 155.312Z",
    fill: "url(#paint0_linear_2101_15132)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.391 158.244C261.145 177.297 247.626 193.266 229.316 197.772C228.048 206.632 223.629 214.594 217.132 220.326C213.756 223.336 209.856 225.702 205.626 227.304V227.501C205.626 240.713 195.826 251.672 183.116 253.488C180.995 258.06 177.823 261.954 173.907 264.951C169.353 268.434 163.91 270.564 158.201 271.097L99.2039 212.101L76.7383 189.657L87.282 179.113L185.326 81.1787L262.391 158.244Z",
    fill: "url(#paint1_linear_2101_15132)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.25 11.7469V259.503C130.681 260.225 130.091 260.903 129.456 261.559C129.15 261.909 128.822 262.216 128.494 262.544C128.188 262.85 127.838 263.156 127.509 263.462C127.159 263.769 126.809 264.053 126.459 264.337C125.431 265.191 124.316 265.956 123.178 266.656C123.156 266.678 123.134 266.678 123.112 266.7C118.334 269.675 112.817 271.251 107.188 271.25C95.1562 271.25 84.3281 264.141 79.3844 253.487C66.675 251.672 56.875 240.712 56.875 227.5V227.303C50.6514 224.941 45.1729 220.957 41.0074 215.764C36.8418 210.572 34.1408 204.36 33.1844 197.772C13.9344 193.025 0 175.634 0 155.312C0 144.834 3.74062 134.794 10.4562 126.941C5.09931 120.038 2.19038 111.55 2.1875 102.812C2.1875 86.5375 11.9437 72.3406 26.5562 66.3906C26.3594 64.7062 26.25 62.9781 26.25 61.25C26.25 40.3375 41.7375 23.0125 61.8625 20.125C63.8094 19.8406 65.8 19.6875 67.8125 19.6875C71.3344 19.6875 74.7688 20.125 78.0938 20.9562C82.1188 8.70625 93.6031 0 107.188 0C116.944 0 125.628 4.61562 131.25 11.7469Z",
    fill: "url(#paint2_linear_2101_15132)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.251 135.21V244.147L76.7383 189.657L131.251 135.21Z",
    fill: "url(#paint3_linear_2101_15132)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M184.406 20.9564C177.825 24.15 172.732 29.761 170.187 36.6189C169.718 37.877 168.876 38.9617 167.774 39.728C166.671 40.4942 165.361 40.9054 164.019 40.9064C163.275 40.9064 162.487 40.7752 161.744 40.4908C160.115 39.8787 158.794 38.6478 158.069 37.0662C157.344 35.4847 157.273 33.6806 157.872 32.0471C161.481 22.3127 168.525 14.4158 177.691 9.66895C180.709 12.8627 183.006 16.6908 184.406 20.9564Z",
    fill: "url(#paint4_linear_2101_15132)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M217.13 220.325C213.754 223.336 209.854 225.701 205.624 227.303C205.143 225.16 204.093 223.147 202.605 221.484C200.199 218.772 200.418 214.638 203.13 212.21C204.425 211.052 206.126 210.454 207.861 210.549C209.595 210.643 211.221 211.421 212.383 212.713C214.396 214.966 216.014 217.547 217.13 220.325ZM183.114 253.488C180.993 258.059 177.821 261.953 173.905 264.95C172.024 264.25 170.23 263.331 168.524 262.194C165.505 260.181 164.718 256.091 166.73 253.072C167.701 251.63 169.204 250.632 170.91 250.296C172.615 249.959 174.384 250.313 175.83 251.278C177.974 252.722 180.511 253.488 183.114 253.488Z",
    fill: "#FCAA1A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0938 20.9564C84.7 24.1721 89.7531 29.7502 92.3125 36.6189C93.2969 39.2658 95.8125 40.9064 98.4812 40.9064C99.225 40.9064 100.013 40.7752 100.756 40.4908C102.385 39.8787 103.706 38.6478 104.431 37.0662C105.156 35.4847 105.227 33.6806 104.628 32.0471C101.048 22.3744 93.9785 14.3915 84.8094 9.66895C81.765 12.8895 79.4715 16.7443 78.0938 20.9564Z",
    fill: "url(#paint5_linear_2101_15132)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3711 220.325C48.747 223.336 52.6471 225.701 56.8773 227.303C57.3586 225.16 58.4086 223.147 59.8961 221.484C62.3023 218.772 62.0836 214.638 59.3711 212.21C58.0762 211.052 56.375 210.454 54.6406 210.549C52.9061 210.643 51.2797 211.421 50.118 212.713C48.1055 214.966 46.4867 217.547 45.3711 220.325ZM79.3867 253.488C81.5086 258.059 84.6805 261.953 88.5961 264.95C90.4773 264.25 92.2711 263.331 93.9773 262.194C96.9961 260.181 97.7836 256.091 95.7711 253.072C94.8 251.63 93.2971 250.632 91.5916 250.296C89.886 249.959 88.1167 250.313 86.6711 251.278C84.5273 252.722 81.9898 253.488 79.3867 253.488Z",
    fill: "#10A0F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M189.635 183.815C187.663 188.39 184.016 192.037 179.441 194.009C164.129 200.681 147.679 204.006 131.251 204.006C114.671 204.021 98.2661 200.618 83.0602 194.009C78.4853 192.037 74.8381 188.39 72.8664 183.815C59.5445 153.19 59.5445 118.059 72.8664 87.4342C74.857 82.8404 78.4664 79.2311 83.0602 77.2404C113.685 63.9186 148.816 63.9186 179.441 77.2404C184.035 79.2311 187.645 82.8404 189.635 87.4342C202.957 118.059 202.957 153.19 189.635 183.815Z",
    fill: "url(#paint6_linear_2101_15132)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M122.103 109.32C121.644 108.053 120.805 106.959 119.702 106.186C118.599 105.413 117.284 104.998 115.937 104.998C114.59 104.998 113.275 105.413 112.172 106.186C111.068 106.959 110.23 108.053 109.77 109.32L92.2703 157.445C91.6753 159.081 91.7546 160.886 92.4905 162.463C93.2265 164.04 94.5589 165.261 96.1947 165.856C97.8304 166.451 99.6356 166.371 101.213 165.635C102.79 164.9 104.011 163.567 104.606 161.931L106.216 157.499H125.658L127.27 161.929C127.865 163.564 129.085 164.897 130.662 165.633C132.239 166.368 134.044 166.448 135.679 165.854C136.489 165.559 137.233 165.108 137.869 164.526C138.504 163.944 139.019 163.242 139.383 162.461C139.748 161.68 139.955 160.835 139.993 159.974C140.03 159.113 139.898 158.253 139.603 157.443L122.103 109.32ZM110.989 144.374L115.937 130.764L120.885 144.374H110.989ZM159.687 104.999C157.946 104.999 156.277 105.691 155.046 106.922C153.816 108.152 153.124 109.821 153.124 111.562V159.687C153.124 161.427 153.816 163.097 155.046 164.327C156.277 165.558 157.946 166.249 159.687 166.249C161.427 166.249 163.097 165.558 164.327 164.327C165.558 163.097 166.249 161.427 166.249 159.687V111.562C166.249 109.821 165.558 108.152 164.327 106.922C163.097 105.691 161.427 104.999 159.687 104.999Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2101_15132",
    x1: 82.6289,
    y1: 0,
    x2: 262.5,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#FFC242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC753F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2101_15132",
    x1: 294.828,
    y1: 299.213,
    x2: 160.535,
    y2: 164.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#F99E0D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#F49020",
    stopOpacity: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#E86D50",
    stopOpacity: 0.233
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#E25D66",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2101_15132",
    x1: 0,
    y1: 0,
    x2: 131.25,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#02C0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2101_15132",
    x1: 200.409,
    y1: 258.847,
    x2: 98.8123,
    y2: 157.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#A4EEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#66CAFF",
    stopOpacity: 0.508
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#27A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2101_15132",
    x1: 157.469,
    y1: 9.66895,
    x2: 184.406,
    y2: 9.66895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#FFC242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC753F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2101_15132",
    x1: 78.0938,
    y1: 9.66895,
    x2: 105.031,
    y2: 9.66895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#02C0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2101_15132",
    x1: 62.8761,
    y1: 135.627,
    x2: 199.628,
    y2: 135.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A47AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#8954DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6936BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.5b917b6c4475d7e460d49bac303ca643.svg";
export { ForwardRef as ReactComponent };